import React, { useState, useEffect } from "react";
import HomeHeader from "../../../pages/HomePage/HomeHeader";
import axios from "axios";
import moment from "moment";
import { Helmet } from "react-helmet";
export const PrivacyPolicy = () => {
  const language = localStorage?.getItem("language") || "english";
  const [publishedPolicy, setPublishedPolicy] = useState("");

  //   const decodeHtml = (htmlString) => {
  //     const doc = new DOMParser().parseFromString(htmlString, "text/html");
  //     return doc.documentElement.textContent || "";
  //   };

  const getPublishedPolicy = async () => {
    await axios.get(`/api/content?type=privacy&isPaginated=false`).then((res) => {
      let allPolicy = res?.data?.data?.results;
      let publishedPolicy = allPolicy?.filter((item) => item?.isActive)[0];
      setPublishedPolicy({
        ...publishedPolicy,
        englishContent: (language === "english" && publishedPolicy?.englishContent) || "",
        arabicContent: (language === "arabic" && publishedPolicy?.arabicContent) || "",
      });
    });
  };
  useEffect(() => {
    getPublishedPolicy();
      //eslint-disable-next-line
  }, []);

  const getContent = () => {
    if (!publishedPolicy) return "";
    return (language === "arabic" ? publishedPolicy.arabicContent : publishedPolicy.englishContent) === (undefined || "undefined")
      ? ""
      : language === "arabic"
      ? publishedPolicy?.arabicContent
      : publishedPolicy?.englishContent;
  };

  return (
    <div style={{ backgroundColor: "white", height: "100%" }}>
      <Helmet>
        <html lang={language === "arabic" ? "ar" : "en"} />

        <title>{language === "arabic" ? "سياسة الخصوصية | فاتورتي" : "Privacy Policy | Fatoraty"}</title>

        <meta
          name="description"
          content={language === "arabic" ? "سياسة الخصوصية الخاصة بمنصة فاتورتي" : "Read Fatoraty privacy policy and data protection information."}
        />

        <meta property="og:title" content={language === "arabic" ? "سياسة الخصوصية | فاتورتي" : "Privacy Policy | Fatoraty"} />

        <meta
          property="og:description"
          content={language === "arabic" ? "سياسة الخصوصية الخاصة بمنصة فاتورتي" : "Read Fatoraty privacy policy and data protection information."}
        />

        {/* <link rel="canonical" href={"https://staging.fatoraty.com/privacy-policy"} /> */}
        <link rel="canonical" href={"http://localhost:3000/privacy-policy"} />
      </Helmet>
      <HomeHeader />
      <div style={{ marginTop: "7rem", background: "white" }}>
        {" "}
        <div className=" p-4">
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              direction: language === "arabic" ? "rtl" : "ltr",
              textAlign: language === "arabic" ? "right" : "left",
            }}
          >
            <div style={{ fontWeight: "400", fontSize: "18px", color: "#333333" }}>{language === "arabic" ? "سياسة الخصوصية" : "Privacy Policy"}</div>
            <p style={{ color: "#333333", fontSize: "13px", fontWeight: "400" }}>
              {" "}
              {language === "arabic" ? " آخر تحديث" : "Last Update"} {moment(publishedPolicy?.updated_at)?.format("DD MMM YYYY")}{" "}
            </p>
            <div style={{ paddingTop: "2rem" }} className="terms-content" dangerouslySetInnerHTML={{ __html: getContent() }} />
          </div>
        </div>
      </div>
      {/* <HomeFooter /> */}
    </div>
  );
};
